import css from './Single.module.scss'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Breakpoints } from 'meta/layout/breakpoints'
import { Routes } from 'meta/routes'

import { Grid, GridColumn } from 'components/Layout/Grid'
import { useCurrentLanguage } from 'hooks/useCurrentLanguage'
import { usePerformerDetails } from 'hooks/usePerformer'

import EventListItemSkeleton from '../../EventList/EventListItem/EventListItemSkeleton'

interface Props {
  code: string
}

const Single: React.FC<Props> = (props) => {
  const { code } = props

  const language = useCurrentLanguage()

  const navigate = useNavigate()

  const data = usePerformerDetails({ id: code, language })

  if (!data) {
    return <EventListItemSkeleton />
  }

  return (
    <div className={css.singleArtistContainer} onClick={() => navigate(Routes.Performer.generatePath({ id: code }))}>
      <Grid>
        <GridColumn
          gridColumnStart={{ [Breakpoints.mobile]: 1, [Breakpoints.laptop]: 1 }}
          gridColumnEnd={{ [Breakpoints.mobile]: 2, [Breakpoints.laptop]: 2 }}
        >
          <img src={data.assets?.find((x) => x.format == 'SQUARE')?.url} className={css.image} />
        </GridColumn>
        <GridColumn
          className={css.nameContainer}
          gridColumnStart={{ [Breakpoints.mobile]: 2, [Breakpoints.laptop]: 2 }}
          gridColumnEnd={{ [Breakpoints.mobile]: 17, [Breakpoints.laptop]: 9 }}
        >
          <h3 className={css.name}>{data.name}</h3>
        </GridColumn>
      </Grid>
    </div>
  )
}

export default Single
